import {ReactNode, useId} from "react";
import {Button, Modal, Spinner} from "react-bootstrap";
import {common} from "../i18n";

interface Props {
    show: boolean;
    title: string;
    children: ReactNode;
    confirmLabel: string;
    variant?: string;
    busy?: boolean;
    onConfirm(): void;
    onCancel(): void;
}

export function ConfirmModal({show, title, children, confirmLabel, variant = 'danger', busy, onConfirm, onCancel}: Props) {
    const titleId = useId();
    return (
        <Modal aria-labelledby={titleId} show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title id={titleId}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel} disabled={busy}>{common.cancel}</Button>
                <Button variant={variant} onClick={onConfirm} disabled={busy}>
                    {busy && <Spinner size="sm" className="me-2"/>}{confirmLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
